import { render } from "./SalonCard.vue?vue&type=template&id=5ee99518"
import script from "./SalonCard.vue?vue&type=script&lang=js"
export * from "./SalonCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__